import { render, staticRenderFns } from "./label.vue?vue&type=template&id=9d17dd1a&scoped=true"
import script from "./label.vue?vue&type=script&lang=ts"
export * from "./label.vue?vue&type=script&lang=ts"
import style0 from "./label.vue?vue&type=style&index=0&id=9d17dd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d17dd1a",
  null
  
)

export default component.exports